'use strict'

import Vue from 'vue'
import axios from 'axios'
import { getToken } from '@/utils/auth'
import { store } from '@/store/index'
import subtractMinutes from 'date-fns/subMinutes'

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.common['Authorization'] = ''
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    store.state.loading_axios = true
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(response => {
  store.state.loading_axios = false
  return response
}, async(error) => {
  let data = {}
  let error_tagging = {}
  let string = ''
  let statusCode = 400
  let message = ''
  if (typeof error.response === 'undefined') {
    store.state.loading_axios = false
    string = 'There was a network error.'
    statusCode = 400
    message = 'There was a network error.'
  } else {
    const errorError = error.response.data.error.error
    let errArr = errorError

    string = errArr
    if (typeof errorError !== 'string') {
      string = ''
      errArr = Object.values(errorError)
      for (let index = 0; index < errArr.length; index++) {
        string += errArr.length > 1 ? '- ' + errArr[index] : errArr[index]
      }
    }
    data = error.response.data.error.data
    statusCode = error.response.data.error.status_code
    message = error.response.data.error.message
    error_tagging = error.response.data.error.error_tagging

    store.state.loading_axios = false

    if (statusCode === 401) {
      var tokenExpiryDate = null
      var tenMinutesBeforeExpiry = 0
      var now = Date.now()
      if (typeof store.state.auth_data.expires_time !== 'undefined') {
        tokenExpiryDate = Date.parse(store.state.auth_data.expires_time)
        tenMinutesBeforeExpiry = Date.parse(subtractMinutes(tokenExpiryDate, 30))
      }
      if (!tokenExpiryDate || now > tenMinutesBeforeExpiry) {
        if (store.state.auth_data !== null) {
          if (store.state.auth_data.auth_by === 'BASIC' || store.state.auth_data.auth_by === 'SYSTEM') {
            if (store.state.auth_data.refresh_token) {
              const originalRequest = error.config
              originalRequest._retry = true
              const headers = {
                'Authorization': 'Bearer ' + getToken()
              }
              const dataAuth = {
                client_id: process.env.VUE_APP_CLIENT_ID,
                client_secret: process.env.VUE_APP_CLIENT_SECRET,
                grant_type: 'refresh_token',
                refresh_token: store.state.auth_data.refresh_token,
                scope: ''
              }
              return new Promise((resolve, reject) => {
                if (store.state.auth_data.auth_by === 'BASIC') {
                  axios.post('/customer/auth/refreshtoken', dataAuth, { headers: headers }).then(res => {
                    store.dispatch('save_token', res.data)
                    store.state.loading_axios = false
                    error.config.headers['Authorization'] = 'Bearer ' + res.data.access_token
                    return _axios.request(error.config)
                  }).catch(async() => {
                    await store.dispatch('fetchToken')
                    await store.dispatch('fetchStore')
                    const isRefreshToken = 1
                    reject({
                      statusCode,
                      message,
                      string,
                      data,
                      isRefreshToken
                    })
                  })
                } else {
                  axios.get('/system/refreshtoken', { headers: headers }).then(res => {
                    store.dispatch('save_token', res.data)
                    store.state.loading_axios = false
                    error.config.headers['Authorization'] = 'Bearer ' + res.data.access_token
                    location.reload()
                    return _axios.request(error.config)
                  }).catch(async() => {
                    await store.dispatch('fetchToken')
                    await store.dispatch('fetchStore')
                    const isRefreshToken = 1
                    reject({
                      statusCode,
                      message,
                      string,
                      data,
                      isRefreshToken
                    })
                  })
                }
              })
            } else {
              store.dispatch('fetchToken')
            }
          } else {
            await store.dispatch('remove_token')
            await store.dispatch('fetchToken')
            await store.dispatch('fetchStore')
            location.reload()
          }
        } else {
          store.dispatch('fetchToken')
        }
      }
    }
  }

  return Promise.reject({
    statusCode,
    message,
    string,
    data,
    error_tagging
  })
})

Plugin.install = function(Vue) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
